// extracted by mini-css-extract-plugin
module.exports = {"profileMenuButton":"ob_C7z7PW","profileMenuButton__avatar":"ob_w1wuzT","profileMenuButton__arrowIcon":"ob_QD0Bxp","emailSection":"ob_ivurNv"};